import { CloseIcon } from "components/common/Icons/CloseIcon";
import { Modal } from "components/common/Modal/Modal";
import { IconDelete } from "./IconDelete/IconDelete";
import { useIconSettingsMobile } from "./useIconSettingsMobile";
import { stopPropagation } from "client/utils/stopPropagation";
import { Translate } from "components/common/Translate/Translate";

export const IconSettingsMobile = () => {
    const { activeIconId, handleOutsideClick } = useIconSettingsMobile();
    if (!activeIconId) return null;
    return (
        <Modal
            isOpen={!!activeIconId}
            close={handleOutsideClick}
            backgroundScroll={true}
            overlayBackground="bg-transparent lg:hidden"
            interactiveBackground={true}
        >
            <div className="mt-auto w-full pointer-events-auto text-black dark:text-white" onClick={stopPropagation()}>
                <div className="h-full px-6 pb-4 flex flex-col gap-6 bg-white dark:bg-darkSurface-200 rounded-t-3xl pt-6 shadow-[0_-15px_60px_-15px_rgba(0,0,0,0.3)]">
                    <div className="relative flex justify-around items-center">
                        <div className="text-lg mx-auto capitalize">
                            <Translate keyName="icon-settings" />
                        </div>
                        <Close onClick={handleOutsideClick} />
                    </div>
                </div>
                <IconDelete close={handleOutsideClick} />
            </div>
        </Modal>
    );
};

interface CloseProps {
    onClick: () => void;
}

const Close = ({ onClick }: CloseProps) => {
    return (
        <div
            className="absolute right-0 top-0 bottom-0 flex items-center justify-center bg-irGray-300 dark:bg-darkSurface-300 rounded-full w-6 h-6"
            onClick={onClick}
        >
            <CloseIcon />
        </div>
    );
};
